import './DocumentsAdministratifs.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';

function SideBarAddExpert({role}) {
    SideBarAddExpert.propTypes = {
        role : PropTypes.any,
    };
    const { pathname } = useLocation();
    const currentPath = pathname.split('/').pop();
    const { i18n } = useTranslation();
    return (
        <>
            <div className='frame0SideBarClient'>
                <div
                    style={
                        (currentPath == 'AddExpertStep1') ?
                            SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                    }
                >
                    <p
                        style={
                            (currentPath == 'AddExpertStep1') ?
                                SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                        }
                    >{i18n.t('Profil personnel')}</p>
                </div>
                <div
                    style={
                        (currentPath == 'AddExpertStep2') ?
                            SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                    }
                >
                    <p
                        style={
                            (currentPath == 'AddExpertStep2') ?
                                SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                        }
                    >{i18n.t('Données CV')}</p>
                </div>
                <div
                    style={
                        currentPath == 'AddExpertStep3' ?
                            SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                    }
                >
                    <p
                        style={
                            currentPath == 'AddExpertStep3' ?
                                SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                        }
                    >{i18n.t('Préférences')}</p>
                </div>
                {role!='esn' &&
                    <div
                        style={
                            currentPath == 'AddExpertStep4' ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                currentPath == 'AddExpertStep4' ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                        >{i18n.t('Société')}</p>
                    </div>
                }
            </div>
        </>
    );
}

export default SideBarAddExpert;